module.exports = __webpack_public_path__ + "img/cloth_g1_item_07.2194f9e2.svg";